import { AwsAccesses } from "@p0security/integrations-aws-shared/accesses";
import { AwsSshAccesses } from "@p0security/integrations-ssh-shared/accesses/aws";
import { publicKeyParameter } from "@p0security/integrations-ssh-shared/accesses/parameters";
import type { ArgsOf, RequestOf } from "@p0security/shared/types/access/index";
import { Access, Delegate } from "@p0security/shared/types/access/index";

export const FileTransferAccesses = {
  session: Access({
    description: "File transfer session",
    label: "File transfer session",
    maturity: "beta",
    delegation: {
      aws: Delegate({
        resource: "aws",
        accesses: AwsAccesses,
        key: "resource" as const,
      }),
      ssh: Delegate({
        resource: "ssh",
        accesses: AwsSshAccesses,
        key: "session" as const,
      }),
    },
    generated: {},
    parameters: {
      destination: {
        type: "dynamic",
        label: "Destination",
        description: "Destination for file transfer",
      },
      publicKey: publicKeyParameter,
      resource: {
        type: "object",
        label: "Resource data",
        properties: {
          accountId: { type: "generated", label: "Account ID" },
          instanceId: { type: "generated", label: "Instance ID" },
          instanceName: { type: "generated", label: "Instance name" },
          arn: { type: "generated", label: "ARN" },
          region: { type: "generated", label: "Region" },
          bucketName: { type: "generated", label: "Bucket name" },
          bucketRegion: { type: "generated", label: "Bucket region" },
          objectPrefix: { type: "generated", label: "Object prefix" },
        },
      },
    },
    render: { locator: "destination" } as const,
  }),
};

export type FileTransferAccesses = typeof FileTransferAccesses;
export type FileTransferAccess =
  FileTransferAccesses[keyof FileTransferAccesses];

export type FileTransferSessionAccess = FileTransferAccesses["session"];
export type FileTransferSessionAccessArgs = ArgsOf<FileTransferSessionAccess>;
export type FileTransferSessionRequest = RequestOf<FileTransferSessionAccess>;
